import AnnouncementCard from './AnnouncementCard';
import {Announcement} from '../type/Announcement';

export default function AnnouncementList(props: { announcements: Announcement[] }) {

	return (
		<div className="announcement-list">
			{
				props.announcements.map((announcement) => {
					return <AnnouncementCard
						announcement={announcement}
						key={announcement.announcementID} />
				})
			}
		</div>
	);
}
